import React, { useEffect, useState } from "react";
import Hero from "../../sections/Hero/Hero";
import Services from "../../sections/Services/Services";
import Navbar from "../../components/Navbar/Navbar";
import { BackToTopButton, WhatsAppButton } from "./styles";
import { ArrowUp } from "lucide-react";
import Project from "../../sections/Projects/Projects";
import Footer from "../../sections/Footer/Footer";
import { FaWhatsapp } from "react-icons/fa";

const Home = () => {
    const [showButton, setShowButton] = useState(false);
    const message = encodeURIComponent(
        "Hola, me interesa conocer los servicios de NanoCode y me gustaría cotizar una solución para mi negocio. ¿Podrían brindarme más información?"
    );

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 200) {
                return setShowButton(true);
            } else {
                setShowButton(false);
            };
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollTo = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <>
            <Navbar />
            <Hero />
            <Services />
            <Project />
            <Footer />

            <WhatsAppButton
                href={`https://wa.me/5213316710897?text=${message}`}
                target="_blank"
                rel="noopener noreferrer"
                $visible={showButton}
            >
                <FaWhatsapp size={24}/>
            </WhatsAppButton>
            <BackToTopButton
                $visible={showButton}
                onClick={scrollTo}
            >
                <ArrowUp size={22}/>
            </BackToTopButton>
        </>
    )
};

export default Home;